module.exports = __webpack_public_path__ + "img/checkmark-colored-icon.9f5c4fd1.svg";